import React, { Fragment, useState } from 'react';
import { TitleBar } from 'styles/layout/titlebar';
import useTitle from 'hooks/useTitle';
import { Content } from 'styles/globalStyles';
import BillingAnalytics from 'components/billing/billingAnalytics/billingAnalytics';
import JsxHelper from 'helpers/jsx';
import DateHelper from 'helpers/date';

const BusinessPerformance = () => {
  useTitle('Business Performance');

  const BREADCRUMBS = JsxHelper.createBreadcrumbs(`Business Performance`, 'reports');
  const [fromDate, setFromDate] = useState(DateHelper.now().subtract(6, 'months').format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(DateHelper.now().add(1, 'day').format('YYYY-MM-DD'));

  const onDateChange = (e) => {
    const { name, value } = e.target;
    if (name === 'from') {
      setFromDate(value);
    } else if (name === 'to') {
      setToDate(value);
    }
  };

  return (
    <Fragment>
      <TitleBar>
        <TitleBar.Title breadcrumbs={BREADCRUMBS}>Business Performance</TitleBar.Title>
        <TitleBar.Actions>
          {JsxHelper.createDateInput({
            label: 'From',
            name: 'from',
            value: fromDate,
            onChange: onDateChange,
          })}
          {JsxHelper.createDateInput({
            label: 'To',
            name: 'to',
            value: toDate,
            onChange: onDateChange,
          })}
          {JsxHelper.createBackButton('/reports')}
        </TitleBar.Actions>
      </TitleBar>
      <Content style={{ margin: '40px 50px' }}>
        <BillingAnalytics fromDate={fromDate} toDate={toDate} />
      </Content>
    </Fragment>
  );
}

export default BusinessPerformance;
